module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "left_wrap"
  }, [_c('Introduce'), _vm._v(" "), _c('Promotion'), _vm._v(" "), _c('NoticeList', {
    attrs: {
      "clickHandler": _vm.clickHandler,
      "isAdmin": _vm.isAdmin
    }
  })], 1), _vm._v(" "), (_vm.viewSample) ? _c('div', {
    staticClass: "right_wrap"
  }, [_c('SamplePage'), _vm._v(" "), _c('SampleVideo')], 1) : _vm._e(), _vm._v(" "), (_vm.isShow) ? _c('NoticeDetail', {
    attrs: {
      "closeHandler": _vm.closeHandler,
      "notice": _vm.notice
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b6904a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainScreen/MainScreen.vue
// module id = 832
// module chunks = 1